import SvgIcon from './svgIcon.vue';

export default SvgIcon;
